<template>
  <div id="pdf-sidebar detail-height">
    <b-overlay
      :show="displayOverlay"
      rounded="sm"
    >
      <div class="h-full">
        <vue-perfect-scrollbar
        :settings="settings"
        class="scroll-pdf-viewer"
        :suppressScrollX="true"
        >
          <!-- Pdf Header -->
          <div class="pdf-viewer">
            <header>
              <slot name="header"></slot>
            </header>
          </div>
          <!-- /Pdf Header -->

          <PDFDocument
            v-bind="{newsId, url, scale}"
            @updateScaleDocumentEvent="updateScaleViewer"
            @updateOverlay="updateOverlay"
          />

        </vue-perfect-scrollbar>
      </div>
    </b-overlay>

    <!-- Customizer Content -->
    <!-- <vs-sidebar hidden-background position-right v-model="active" class="items-no-padding"></vs-sidebar> -->
  </div>
</template>


<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import PDFDocument from "./PDFDocument.vue";
import { BOverlay } from 'bootstrap-vue';
// import pdfjs from 'pdfjs-dist'

export default {
  props: {
    newsId: {
      type: String,
      require: true
    },
    url: {
      type: String,
      require: true
    },
    scale: {
      type: Number,
      require: true
    },
  },
  watch: {},
  data() {
    return {
      active: true,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
        swipeEasing: true,
      },
      displayOverlay: false
    };
  },
  components: {
    VuePerfectScrollbar,
    PDFDocument,
    BOverlay
  },
  methods: {
    updateScaleViewer(scale) {
      this.$emit("updateScaleViewerEvent", scale);
    },
    updateOverlay(value) {
      this.displayOverlay = value;
    }
  }
};
</script>

<style lang="scss">
.detail-height {
  height: 580px;

}
#pdf-sidebar {
  .vs-sidebar {
    position: fixed;
    z-index: 52000;
    width: 100%;
    max-width: 90vw;
    // @apply shadow-lg;
    box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.11),
      0 5px 15px 0 rgba(0, 0, 0, 0.08);
  }
}

.scroll-pdf-viewer {
  height: calc(100% - 5rem);
  border-radius: 8px;
}

header {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
}

.pdf-toolbar {
  display: flex;
  justify-content: center;
  width: 100%;
  padding-top: 4px;
  background-color: white;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.04);
}

.header-item {
  // margin: 0.25em 2.5em;
}

@media print {
  header {
    display: none;
  }
}
</style>
